module.exports = __webpack_public_path__ + "static/tool-6ea64d7583071666eb2375dc2ef6cdce.png";